__turbopack_context__.v({
  "container": "qIzo4G_container",
  "fallbackImage": "qIzo4G_fallbackImage",
  "mediaContainer": "qIzo4G_mediaContainer",
  "root": "qIzo4G_root" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "unicornEmbed": "qIzo4G_unicornEmbed",
});
